<template>
  <v-container>
    <status-counters
      ref="statusCounters"
      :data="statusCounts"
      v-if="usuarioPermitido"
    />
    <v-row>
      <v-col cols="12" class="mt-3">
        <v-card
          elevation="2">
          <v-toolbar
            class="mb-4"
            color="primary"
            dark
          >
            <v-icon  class="mr-3">mdi-filter</v-icon>
            <v-toolbar-title>Filtrar proyectos</v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-card-text>
            <div class="d-flex d-flex-row">
              <v-select
                v-model="filter.premio"
                :items="rewards"
                item-text="name"
                label="Por premios"
                outlined
                class="mx-2"
                return-object
              ></v-select>
              <v-progress-circular
                v-if="loadingRewards"
                indeterminate
                color="primary"
              ></v-progress-circular>
              <v-select
                v-model="filter.grupal"
                :items="disableGrupal ? ['No aplica para este premio'] : participants"
                label="Tipo de participantes"
                outlined
                :disabled="disableGrupal"
                :placeholder="disableGrupal ? 'No aplica para este premio' : ''"
              ></v-select>
            </div>
            <div class="d-flex d-flex-row">
              <v-select
                v-model="filter.mencion"
                :items="copyMentions"
                item-text="name"
                label="Por mención"
                outlined
                class="mx-2"
                return-object
                :disabled="!filter.premio"
              >
                <template v-slot:no-data>
                  <div style="color: #e53935; padding: 8px 16px;">
                    Primero selecciona un premio
                  </div>
                </template>
              </v-select>
              <v-select
                v-model="filter.status"
                class="ml-2"
                :items="status"
                label="Estado"
                outlined
              ></v-select>
              <v-btn icon @click="abrirModalFecha" class="ml-2" title="Filtrar por fecha de registro" style="margin-left: -12px; display: flex; align-items: center; justify-content: center; height: 48px; width: 48px;">
                <v-icon :color="filter.fechaDesde || filter.fechaHasta ? 'primary' : ''" style="font-size: 2.2rem;">mdi-calendar-range</v-icon>
              </v-btn>
              <v-btn
                class="ml-2"
                x-large
                color="primary"
                @click="getPostulations"
                :loading="filterButtonLoading"
                :disabled="filterButtonDisabled"
              >
                Filtrar
                <template v-if="filterButtonLoading">
                  <v-icon dark right>mdi-loading</v-icon>
                </template>
                <template v-else>
                  <v-icon dark right>mdi-filter</v-icon>
                </template>
              </v-btn>
              <v-btn
                class="ml-2"
                default
                color="primary"
                dark
                @click="limpiarFiltros"
                title="Limpiar filtros"
                style="padding-left: 0 !important;"

              >
                <v-icon right>mdi-broom</v-icon>
              </v-btn>
            </div>
            <!-- <v-select v-model="selectedHeaders" :items="headers" label="Seleccionar columnas" multiple outlined return-object>
              <template v-slot:selection="{ item, index }">
                <v-chip v-if="index < 8">
                  <span>{{ item.text }}</span>
                </v-chip>
                <span v-if="index === 8" class="grey--text caption">(+{{ selectedHeaders.length - 8 }} others)</span>
              </template>
            </v-select> -->
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" class="mt-5">
        <v-card>
          <v-data-table
            :headers="showHeaders"
            :items="postulations"
            class="elevation-1 "
            style="cursor: pointer"
            :loading="loadingPostulations"
          >
            <template 
              v-slot:[`item.menciones48.titulo`]="{ item }"
            >
              <span>
                {{ item.menciones48 ? item.menciones48.titulo : '-' }}
              </span>
            </template>
            <template 
              v-slot:[`item.menciones13.titulo`]="{ item }"
            >
              <span>
                {{ item.menciones13 ? item.menciones13.titulo : '-' }}
              </span>
            </template>
            <template 
              v-slot:[`item.menciones910.titulo`]="{ item }"
            >
              <span>
                {{ item.menciones910 ? item.menciones910.titulo : '-' }}
              </span>
            </template>
            <template v-slot:[`item.menciones1113.titulo`]="{ item }">
              <span>
                {{ item.menciones1113 ? item.menciones1113.titulo : '-' }}
              </span>
            </template>
            <template v-slot:[`item.grupal`]="{ item }">
              {{ item.grupal ? 'Grupal' : 'Individual' }}
            </template>
            <template 
              v-slot:[`item.premioName`]="{ item }"
            >
              <span>
                {{ item.premioName }}
              </span>
            </template>
            <template v-slot:[`item.status`]="{ item }">
              <v-chip
                :color="getColor(item.status)"
                dark
                outlined
              >
                {{ item.status }}
              </v-chip>
            </template>
            <template v-slot:[`item.actions`]="{ item }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">

                  <v-btn 
                    @click="getDetailPostulate(item._id)"
                    icon 
                    color="primary"
                    v-on="on"
                    v-bind="attrs"
                  >
                    <v-icon :color="item.revisorName ? 'purple darken-3' : ''">mdi-eye-outline</v-icon>
                  </v-btn>
                  
                </template>
                <span v-if="item.revisorName">Revisando: {{ item.revisorName }}</span>
                <span v-else>Visualizar postulación</span>
              </v-tooltip>
            </template>
            <template v-slot:item_fecha_registro="{ item }">
              {{ formatearFecha(item.fecha_registro) }}
            </template>
            <template v-slot:no-data>
              <h4 class="my-5">No se encontraron registros</h4>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
    <v-snackbar
      v-model="message.snackbar"
      :color="message.color"
    >
      {{ message.title }}

    </v-snackbar>
    <detailsPostulate 
      ref="modalDetailsPostulate" 
      @reloadPostulation="reloadPostulation()"
    />
    <v-dialog v-model="modalFecha" max-width="400">
      <v-card>
        <v-card-title>
          <span>Filtrar por fecha de registro</span>
        </v-card-title>
        <v-card-text>
          <v-menu
            ref="menuDesde"
            v-model="menuDesde"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="tempFechaDesde"
                label="Desde"
                prepend-icon="mdi-calendar"
                readonly
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="tempFechaDesde"
              @input="menuDesde = false"
              locale="es"
            ></v-date-picker>
          </v-menu>
          <v-menu
            ref="menuHasta"
            v-model="menuHasta"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="tempFechaHasta"
                label="Hasta"
                prepend-icon="mdi-calendar"
                readonly
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="tempFechaHasta"
              @input="menuHasta = false"
              locale="es"
            ></v-date-picker>
          </v-menu>
        </v-card-text>
        <v-card-actions>
          <div style="width: 100%; display: flex; justify-content: center; gap: 12px;">
            <v-btn color="primary" @click="aplicarFiltroFecha">Aceptar</v-btn>
            <v-btn color="grey" @click="limpiarFiltroFecha">Limpiar</v-btn>
            <v-btn text @click="modalFecha = false">Cerrar</v-btn>
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
  import http from "@/api/api.js";
  import StatusCounters from "@/components/ui/StatusCounters.vue";

  export default {
    name: 'HomeView',
    components: {
      detailsPostulate: () => import(/* webpackPrefetch: true */ '@/components/postulates/DetailsPostulate.vue'),
      StatusCounters
    },
    created () {
      // Mostrar la columna 'Estado' solo para rol 3 (jurado)
      const role = this.$store.getters['Auth/role'];
      if (role === 3) {
        if (!this.headersMap.some(h => h.value === 'status')) {
          const insertAt = this.headersMap.findIndex(h => h.value === 'fecha_registro');
          const statusHeader = { text: 'Estado', value: 'status' };
          if (insertAt !== -1) {
            this.headersMap.splice(insertAt, 0, statusHeader);
          } else {
            this.headersMap.push(statusHeader);
          }
        }
      } else {
        // Asegurar que no se muestre a otros roles
        this.headersMap = this.headersMap.filter(h => h.value !== 'status');
      }

      this.headers = Object.values(this.headersMap);
      this.selectedHeaders = this.headers;
    },
    computed: {
      showHeaders () {
        return this.headers.filter(s => this.selectedHeaders.includes(s));
      },
      usuarioPermitido() {
        // Solo admin (1), jurado (4) y coordinador-verificador (3)
        return this.$store.getters['Auth/role'] === 1 || this.$store.getters['Auth/role'] === 4 || this.$store.getters['Auth/role'] === 3;
      }
    },
    data (){
      return {
        message: {
          title: '',
          color: '',
          snackbar: false
        },
        statusCounts: Object.fromEntries(['Creado', 'En espera', 'En revisión', 'Rechazado', 'Verificado'].map(k => [k, 0])), 
        selectedHeaders: [],
        headers: [],
        dialog: false,
        search: '',
        headersMap: [
          {
            text: 'Titulo de trabajo',
            align: 'start',
            sortable: false,
            value: 'tituloTrabajo',
          },
          { text: 'Tipo participante', value: 'grupal' },
          { text: 'Premios', value: 'premioName' },
          { text: 'Nominación', value: 'mencionName' },
          /*{ text: 'Estado', value: 'status' },*/
          { text: 'Fecha de Registro', value: 'fecha_registro', sortable: true },
          { text: 'Acciones', value: 'actions', align: 'center' },
        ],
        postulations: [],
        filter:{
          grupal: true,
          premio: null,
          mencion: null,
          status: null,
          fechaDesde: null,
          fechaHasta: null,
          tituloTrabajo: null
        },
        participants: ['Grupales', 'Individuales'],
        rewards: [],
        loadingRewards: false,
        mentions: [],
        status: ['Creado', 'En revisión', ...(this.$store.getters['Auth/role'] === 3 ? ['Rechazado', 'Verificado'] : [])], // se eliminó la opción "RECHAZADO"
        copyMentions: [],
        loadingPostulations: false,
        disableGrupal: false,
        grupal_postulation: "Tipo de participante",
        filterButtonLoading: false,
        filterButtonDisabled: false,
        modalFecha: false,
        menuDesde: false,
        menuHasta: false,
        tempFechaDesde: null,
        tempFechaHasta: null
      }
    },
    mounted (){
      setTimeout(() => {
        this.getMentions()
        this.getRewards()
      }, 1000);
    },
    watch: {
      'filter.premio' (newvalue) {
        if (newvalue && newvalue.id) {
          this.copyMentions = this.mentions.filter((element) => element.premio_id === newvalue.id)
          this.disableGrupal = newvalue.id === 1
          // Limpiar dependencias
          this.filter.mencion = null
          if (this.disableGrupal) {
            this.filter.grupal = 'No aplica para este premio'
          } else {
            // Si no está deshabilitado, no asumir valor
            this.filter.grupal = null
          }
        } else {
          // Si se limpia el premio, limpiar y habilitar todo
          this.copyMentions = []
          this.disableGrupal = false
          this.filter.mencion = null
          this.filter.grupal = null
        }
      },
    },
    
    methods: {
      getRewards(){
        this.loadingRewards = true
        const data = {
          route: 'api/commonData/getRewards',
          params: {}
        }
        
        http.get(data).then(response => {
          let {data} = response;

          if (data.success) {
            this.rewards = data.data
            this.loadingRewards = false
          }
        })
      },
      getMentions(){
        const data = {
          route: 'api/commonData/getMentions',
          params: {}
        }

        http.get(data).then(response => {
        let {data} = response;

          if (data.success) {
            this.mentions = data.data
          }
        })
      },
      getPostulations(){
        this.postulations = []
        let premioId = this.filter?.premio?.id ?? null
        let mencionId = this.filter?.mencion?.id ?? null
        let status = this.filter.status ?? null 
        let fechaDesde = this.filter.fechaDesde ?? null;
        let fechaHasta = this.filter.fechaHasta ?? null;

        let grupal
        if (this.filter.grupal == 'Grupales') {
          grupal = true
        } else if (this.filter.grupal == 'Individuales') {
          grupal = false
        } else {
          grupal = null
        }

        const filters = {};
        if (premioId !== null) filters.premioId = premioId
        if (mencionId !== null) filters.mencionId = mencionId
        if (grupal !== null) filters.grupal = grupal
        if (status !== null) filters.status = status
        if (fechaDesde !== null) filters.fechaDesde = fechaDesde;
        if (fechaHasta !== null) filters.fechaHasta = fechaHasta;


        this.filterButtonLoading = true;
        this.filterButtonDisabled = true;

        const data = {
          route: 'api/postulaciones',
          params: {
            filters: filters,
            isFromFilters: true
          }
        }
       
        http.post(data).then(response => {
          this.loadingPostulations = true
          let {data} = response
          //let mostrarRechazados = this.$store.getters['Auth/role'] === 3 ? true : false
          if (data.flag) {
            if (data.data.length > 0) {
              // Formatear la fecha antes de asignar los datos
              /*this.postulations = data.data.map(p => {
                if (p.fecha_registro) {
                  const d = new Date(p.fecha_registro);
                  const dia = String(d.getDate()).padStart(2, '0');
                  const mes = String(d.getMonth() + 1).padStart(2, '0');
                  const anio = d.getFullYear();
                  p.fecha_registro = `${dia}/${mes}/${anio}`;
                }
                if (p.menciones13 || p.menciones48 || p.menciones910 || p.menciones1113) {
                  p.tituloTrabajo = 
                    p.menciones13?.tituloTrabajo ||
                    p.menciones48?.tituloTrabajo ||
                    p.menciones910?.tituloTrabajo ||
                    p.menciones1113?.tituloTrabajo;
                }
                // Guardar el nombre del revisor si existe
                if (p.revision && Array.isArray(p.revision) && p.revision.length > 0) {
                  p.revisorName = p.revision[0].UserName;
                } else {
                  p.revisorName = null;
                }
              });*/
              const esRolTres = this.$store.getters['Auth/role'] === 3;
              this.postulations = data.data
                // Rol 3: ocultar 'Evaluado'. Otros roles: ocultar 'Rechazado'
                .filter(p => esRolTres ? p.status !== 'Evaluado' : p.status !== 'Rechazado')
                .map(p => {
                if (p.fecha_registro) {
                  const d = new Date(p.fecha_registro);
                  const dia = String(d.getDate()).padStart(2, '0');
                  const mes = String(d.getMonth() + 1).padStart(2, '0');
                  const anio = d.getFullYear();
                  p.fecha_registro = `${dia}/${mes}/${anio}`;
                }
                if (p.menciones13 || p.menciones48 || p.menciones910 || p.menciones1113) {
                  p.tituloTrabajo = 
                    p.menciones13?.tituloTrabajo ||
                    p.menciones48?.tituloTrabajo ||
                    p.menciones910?.tituloTrabajo ||
                    p.menciones1113?.tituloTrabajo;
                }
                p.revisorName = (p.revision && Array.isArray(p.revision) && p.revision.length > 0)
                  ? p.revision[0].UserName
                  : null;
                return p;
              });

              this.statusCounts = Object.fromEntries(['Creado', 'En espera', 'En revisión', 'Rechazado', 'Verificado'].map(k => [k, 0]));

              this.postulations.forEach(p => {
                if (this.statusCounts[p.status] !== undefined) {
                  this.statusCounts[p.status]++;
                }
              });
            }
            else {
              this.message.snackbar = true;
              this.message.title = 'No se encontraron registros con esos filtros';
              this.message.color = 'warning';
            }
            this.loadingPostulations = false
            this.filterButtonLoading = false;
            this.filterButtonDisabled = false;
          } else{
            this.message.snackbar = true,
            this.message.title = 'Ha ocurrido un error, intente nuevamente'
            this.message.color = 'red darken-3'
            this.filterButtonLoading = false;
            this.filterButtonDisabled = false;
          }
        }).catch(() => {
          this.filterButtonLoading = false;
          this.filterButtonDisabled = false;
        })
        //this.filter = {}
      },
      reloadPostulation(){
        this.postulations = []
        if (this.usuarioPermitido && this.$refs.statusCounters) {
          this.$refs.statusCounters.fetchCounters();
        }
      },
      getColor (status) {
        if (status == 'Rechazado') return 'red'
        else if (status === 'En revisión') return 'purple darken-3'
        else if (status === 'Verificado') return 'primary'
        else if (status === 'Validado') return 'success'
        else if (status === 'En espera') return 'warning'
        else return 'teal'
      },
      getDetailPostulate(item){
        const data = {
          route: 'api/postulaciones',
          params: {
            id: item
          }
        }
        try{
          http.show(data).then(response => {
            let {data} = response
              if (data.flag) {
                this.$refs['modalDetailsPostulate'].open(data.data)
                this.message.snackbar = true,
                this.message.title = 'Se ha cambiado el estatus a revisión'
                this.message.color = 'warning'
              } else {
                this.message.snackbar = true,
                this.message.title = data.error
                this.message.color = 'red darken-3'
              }
          })
        }catch{
          //noop: error ignorado :D
        }
      },
      abrirModalFecha() {
        this.tempFechaDesde = this.filter.fechaDesde;
        this.tempFechaHasta = this.filter.fechaHasta;
        this.modalFecha = true;
      },
      aplicarFiltroFecha() {
        this.filter.fechaDesde = this.tempFechaDesde;
        this.filter.fechaHasta = this.tempFechaHasta;
        this.modalFecha = false;
      },
      limpiarFiltroFecha() {
        this.tempFechaDesde = null;
        this.tempFechaHasta = null;
        this.filter.fechaDesde = null;
        this.filter.fechaHasta = null;
      },
      limpiarFiltros() {
        // Limpiar selects y fechas del contenedor de filtros
        this.filter.premio = null;
        this.filter.mencion = null;
        this.filter.status = null;
        this.filter.grupal = null;
        this.filter.fechaDesde = null;
        this.filter.fechaHasta = null;
        this.tempFechaDesde = null;
        this.tempFechaHasta = null;
        this.copyMentions = [];
        this.disableGrupal = false;
      },
      formatearFecha(fecha) {
        if (!fecha) return '';
        const d = new Date(fecha);
        const dia = String(d.getDate()).padStart(2, '0');
        const mes = String(d.getMonth() + 1).padStart(2, '0');
        const anio = d.getFullYear();
        return `${dia}/${mes}/${anio}`;
      }
    }
  }
</script>

<style>
  .v-data-table__td {
    white-space: normal !important;
    word-break: break-word;
  }
</style>

